export const TITLE = 'Header';
export const PLACEHOLDER = 'Welcome to General Biology Assessment #1';
